import Login from './components/Login';
import Messages from './components/Messages';
import Notifications from './components/Notifications';
import Payout from './components/Payout';
import Segments from './components/Segments';
import Users from './components/Users';
import MasterCron from './components/MasterCron';
import NetworkPerformance from './components/NetworkPerformance';
import Stats from './components/Stats';
import Revenues from './components/Revenues';
import Conversions from './components/Conversions';
import BidderCPC from './components/BidderCPC';
import Bidder from './components/Bidder';
import BidderNetworkPerformance from './components/BidderNetworkPerformance';
import BidderNetworkPerformanceV2 from './components/BidderNetworkPerformance.v2';
import BidderError from './components/BidderError';
import BidderECost from './components/BidderECost';
import BidderCtr from './components/BidderCtr';
import BidderCpcCountry from './components/BidderCPCCountry';
import BidderQuality from './components/BidderQuality';
import BidderSources from './components/BidderSources';
import BidderSourcesCountry from './components/BidderSourcesCountry';
import BidderSourcesBlock from './components/BidderSourcesBlock';
import BidderSourcesWhitelist from './components/BidderSourcesWhitelist';
import BidderBids from './components/BidderBids';
import BidderSourcesGraph from './components/BidderSourcesGraph';
import BidderClickLog from './components/BidderClickLog';
import ClickBaitMessages from './components/ClickBaitMessages';
import Pushapi from './components/Pushapi';
import PushapiV2 from './components/Pushapi.v2';
import PushapiV3 from './components/Pushapi.v3';
import PushapiFactor from './components/PushapiFactor';
import PayoutFactor from './components/PayoutFactor';
import PayoutCountryFactor from './components/PayoutCountryFactor';
import AdSense from './components/AdSense';
import ZeroPark from './components/ZeroPark';
import AdKernel from './components/AdKernel';
import PushapiCpc from './components/PushapiCpc';
import PushapiConfig from './components/PushapiConfig';
import PushapiBlock from './components/PushapiBlock';
import SSRotator from './components/SSRotator';
import Servers from "./components/Servers";
import DynamicCutoff from "./components/DynamicCutoff";
import TrackerAffids from "./components/TrackerAffids";
import AdkFeeds from "./components/AdkFeeds";
import AdkLinks from "./components/AdkLinks";
import AdkBids from "./components/AdkBids";
import AkFull from './components/AkFull';
import AdkBidFactor from './components/AdkBidFactor';
import AdkQuickFactor from './components/AdkQuickFactor';
import AdkBlock from './components/AdkBlock';
import AdkPartners from "./components/AdkPartners";
import AdkHourFactor from "./components/AdkHourFactor";
import AdkCountryHourFactor from "./components/AdkCountryHourFactor";
import PushapiCountry from './components/PushapiCountry';
import AdkBanner from './components/AdkBanner';
import DummyCutoff from './components/DummyCutoff';
import DynamicHourlyCutoff from './components/DynamicHourlyCutoff';
import AdkReport from './components/AdkReport';
import AdkReport3 from './components/AdkReport.v3';
import Domains from './components/Domains';
import DomainsV2 from './components/DomainsV2';
import PartnerDomains from './components/PartnerDomains';
import PcCutoff from './components/PcCutoff';
import Sync from './components/Sync';
import CalendarEvents  from './components/CalendarEvents';
import Adk5MinFactor  from './components/Adk5MinFactor';
import BidderFillRate from './components/BidderFillRate';
import Dating from './components/Dating';
import PropellerAds from './components/PropellerAds';
import BidderCtrHourly from './components/BidderCtrHourly';
import History from './components/History';
import PushapiPartners from './components/PushapiPartners';
import AdkPartnerBlock from './components/AdkPartnerBlock';
import AdkCalculus from './components/AdkCalculus';
import AdkBoosters from './components/AdkBoosters';
import BidderSpy from './components/BidderSpy';
import BidderManualOffers from './components/BidderManualOffers';
import BidderWinRateConfig from './components/BidderWinRateConfig';
import BidderWinRateFactors from './components/BidderWinRateFactors';
import PeerClickOffer from './components/PeerClickOffer';
import BidderFeeds from './components/BidderFeeds';
import PeerclickCampaign from "./components/peerclick/PeerclickCampaign";
import apkInstallations from "./components/peerclick/apkInstallations";
import apkInstallationsHourly from "./components/peerclick/apkInstallationsHourly";
import Filler from './components/Filler';
import BidderPartners from "./components/bidderPartners";
import PushapiV4 from "./components/Pushapi/index";
import ContentForYou from "./components/ContentForYou";
import BidderSourcesConfig from "./components/BidderSourcesConfig";
import AdContent from "./components/AdContent";
import PushapiPostback from "./components/PushapiPostback";
import ADKUnblocked from "./components/AdkUnblocked";
import ADKDomains from "./components/AdkDomains";
import TrackerPartners from "./components/TrackerPartners";
import BitbucketDnsDomainChecker from "./components/BitbucketDnsDomainChecker";
import BidderRealtime from "./components/BidderRealtime";
import BidderClickUrlsHourly from "./components/BidderClickUrlsHourly";
import BidderClickUrlsDaily from "./components/BidderClickUrlsDaily";
import BidderPluginReport from "./components/BidderPluginReport";
import AdkPartnerDomains from "./components/AdkPartnerDomains";
import AdkPreDefinedDomains from "./components/AdkPreDefinedDomains";
import AdkPartnerDomainReplacementLog from "./components/AdkPartnerDomainReplacementLog";
import AdkClickDomainReplacementLog from "./components/AdkClickDomainReplacementLog";

const API = {
    Login, Messages, Notifications, Payout, Segments, Users, MasterCron, NetworkPerformance, Stats, BidderPartners, AdContent, TrackerPartners, Revenues, Conversions, BidderCPC, ContentForYou, Bidder, BidderSourcesConfig, BidderNetworkPerformance, BidderECost, BidderSourcesWhitelist, BidderCtr, apkInstallations, apkInstallationsHourly, BidderCpcCountry, BidderQuality, ClickBaitMessages, Pushapi, AdSense, ZeroPark, PushapiFactor, PayoutFactor, AdKernel, PushapiCpc, PushapiConfig, PushapiBlock, SSRotator, BidderSources, BidderSourcesCountry, BidderSourcesBlock, BidderClickLog, Servers, DynamicCutoff, TrackerAffids, AdkFeeds, AdkLinks, AdkBids, AkFull, AdkBidFactor, AdkBlock, AdkPartners, BidderNetworkPerformanceV2, AdkHourFactor, PayoutCountryFactor, PushapiCountry, AdkBanner, AdkQuickFactor, BidderBids, PushapiV2, DummyCutoff, DynamicHourlyCutoff, AdkReport, Domains, PartnerDomains, PcCutoff, Sync, CalendarEvents, BidderSourcesGraph, Adk5MinFactor, BidderFillRate, BidderError, Dating, PropellerAds, AdkReport3, BidderCtrHourly, History, PushapiPartners, AdkPartnerBlock, AdkCalculus, AdkBoosters, BidderSpy, AdkCountryHourFactor, PushapiV3, BidderManualOffers, BidderWinRateConfig, BidderWinRateFactors, PeerClickOffer, PeerclickCampaign, BidderFeeds, Filler, PushapiV4, PushapiPostback, ADKUnblocked, ADKDomains, BitbucketDnsDomainChecker, BidderRealtime, DomainsV2, BidderClickUrlsHourly, BidderClickUrlsDaily, BidderPluginReport, AdkPartnerDomains, AdkPreDefinedDomains, AdkPartnerDomainReplacementLog, AdkClickDomainReplacementLog
};

export default API;



// WEBPACK FOOTER //
// ./src/services/API/index.js